import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Logo from '../../../assets/images/jason-logo.png';
import SearchBox from './SearchBox'

const HeaderMiddle = () => {

  return (
    <div className="header-middle">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 search-bar">
            <div className="logo-container">
              <Link to="/"><img src={Logo} alt='Jasons Wine & Spirit Logo'/></Link>
            </div>
            <SearchBox/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderMiddle;



// WEBPACK FOOTER //
// ./src/components/commons/header/HeaderMiddle.js